<template>
  <div class="modal-box">
    <div class="modal-li">
      <img @click="handleClose" class="close" src="../assets/images/close.png"/>
      <div class="reported-top">
        <div class="reported-img">
          <img :src="avatar" style="border-radius: 50%"/>
        </div>
        <div class="reported-text">
          <div class="reported-h">{{checkNull(msg,'user')}}</div>
          <div class="reported-p">{{checkNull(msg,'title')}}</div>
        </div>
      </div>
      <div class="reported-center">
        <div class="reported-li">
          <div class="ted-h">{{checkNull(msg,'flightNo')}}</div>
          <div class="ted-p">航班号</div>
        </div>
        <div class="reported-li">
          <div class="ted-h">{{checkNull(msg,'planeType')}}</div>
          <div class="ted-p">飞机型号</div>
        </div>
        <div class="reported-li">
          <div class="ted-h">{{checkNull(msg,'planeId')}}/{{checkNull(msg,'msn')}}</div>
          <div class="ted-p">注册号/MSN编号</div>
        </div>
      </div>
      <div class="reported-bottom" v-if="checkNull(msg,'class') === 'TabPlaneErrorRecord'">
        <div class="reported-left" @click="goTabPlaneErrorRecord(checkNull(msg,'id'))">进入查看<img src="@/assets/images/login.png"/></div>
        <div class="reported-right">刚刚</div>
      </div>
      <div class="reported-bottom" v-else-if="checkNull(msg,'class') === 'TabPlaneRiskRecord'">
        <div class="reported-left" @click="goTabPlaneRiskRecord(checkNull(msg,'id'))">进入查看<img src="@/assets/images/login.png"/></div>
        <div class="reported-right">刚刚</div>
      </div>
      <div class="reported-bottom" v-else-if="checkNull(msg,'class') === 'TabPlaneRiskRecordHandle'">
        <div class="reported-left" @click="goTabPlaneRiskRecordHandle(checkNull(msg,'id'))">进入查看<img src="@/assets/images/login.png"/></div>
        <div class="reported-right">刚刚</div>
      </div>
      <div class="reported-bottom" v-else-if="checkNull(msg,'class') === 'TabPlaneCabinEvent'">
        <div class="reported-left" @click="goTabPlaneCabinEvent(checkNull(msg,'id'))">进入查看<img src="@/assets/images/login.png"/></div>
        <div class="reported-right">刚刚</div>
      </div>
    </div>
  </div>
</template>

<script>
  const defaultAvatar = require('@/assets/images/logo.png')

  export default {
    name: "modal",
    props: {
      showdialog: {
        type: Boolean,
        default: false
      },
      msg: {
        type: Object,
        required: true
      },
      role:{
        type: String,
        required: true
      }
    },
    computed: {
      avatar() {
        return this.msg && this.msg.avatar || defaultAvatar
      }
    },
    methods:{
      handleClose() {
        this.$emit('handle-close')
      },
      goTabPlaneErrorRecord(id){
        this.handleClose()
        if (this.role==='ROLE_SOC'){
          this.$router.push(`/malfunction/${id}`)
        }else if (this.role==='ROLE_MECH'){
          this.$router.push(`/malfunctionMech/${id}`)
        }
      },
      checkNull(obj, attr) {
        return attr && obj && obj[attr] ? obj[attr] : ''
      },
      goTabPlaneRiskRecord(id){
        this.handleClose()
        this.$router.push(`/Commitanalogdata/${id}/`)
      },
      goTabPlaneRiskRecordHandle(id){
        this.handleClose()
        // this.$router.push(`/simulator2/${id}/`)
        this.$router.push(`/Commitanalogdata/${id}/`)
      },
      goTabPlaneCabinEvent(id){
        this.handleClose()
        if (['ROLE_SOC', 'ROLE_SCDR'].includes(this.role)) {
          this.$router.push(`/CabinEvent/${this.role}/${id}`)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .modal-box{
    position: fixed;
    right: 300px;
    top: 50px;
  }
  .modal-li{
    background: #393F52;
    border-radius: 12px;
    padding: 20px 12px;
    width: 400px;
    margin-bottom: 16px;
    position: relative;
  }
  .close{
    position: absolute;
    right: 16px;
    cursor: pointer;
    top: 16px;
  }
  .reported-bottom{
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 14px;
    margin-top: 18px;
    .reported-left{
      opacity: .6;
      display: flex;
      align-items: center;
      cursor: pointer;
      img{
        margin-left: 4px;
      }
    }
    .reported-right{
      opacity: .87;
    }
  }
  .reported-center{
    background: #262D40;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    margin-top: 12px;
    .reported-li{
      color: #fff;
      text-align: left;
      padding: 0 16px;
      border-right: 1px solid #393F52;
      flex:1;
      .ted-h{
        font-size: 14px;
        opacity: 0.87;
        margin-bottom: 4px;
      }
      .ted-p{
        font-size: 12px;
        opacity: 0.6;

      }
    }
  }
  .reported-top{
    display: flex;
    align-items: center;
    .reported-img{
      border: 1px solid rgba(255, 255, 255, 0.6);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .reported-text{
      text-align: left;
      margin-left: 14px;
      color: #fff;
      .reported-h{
        font-size: 16px;
        opacity: 0.87;
        margin-bottom: 2px;
      }
      .reported-p{
        font-size: 14px;
        opacity: 0.6;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue